var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2578 2.30469C15.0391 1.8125 14.4648 1.62109 14 1.89453L11.2383 3.5625L10.5 0.5L9.32422 1.375H8.14844L7 0.5L6.23438 3.5625L3.47266 1.89453C3.00781 1.62109 2.43359 1.8125 2.21484 2.30469L0 7.5L1.33984 7.0625C2.10547 6.81641 2.92578 7.08984 3.36328 7.74609L4.375 9.25L4.67578 8.94922C5.44141 8.18359 6.67188 8.26562 7.32812 9.14062L8.75 11L10.1445 9.14062C10.8008 8.26562 12.0312 8.18359 12.7969 8.94922L13.125 9.25L14.1094 7.74609C14.5469 7.08984 15.3672 6.81641 16.1328 7.0625L17.5 7.5L15.2578 2.30469Z",
    fill: "#A21D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComics);
export default __webpack_public_path__ + "static/media/comics.7a223e1f5ef18171e3040112e9d422db.svg";
export { ForwardRef as ReactComponent };